var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02942 16.9706 3 12 3C7.02944 3 3 7.02942 3 12C3 16.9706 7.02944 21 12 21ZM19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12ZM14.9516 11.1918C15.4394 11.1918 15.8347 11.5872 15.8347 12.0749C15.8347 12.5626 15.4394 12.958 14.9516 12.958L11.6129 12.9613C11.5767 12.9613 11.5411 12.9592 11.5061 12.955L11.5 12.955C11.0123 12.955 10.6169 12.5596 10.6169 12.0719L10.6169 8.24887C10.6169 7.76116 11.0123 7.36579 11.5 7.36579C11.9877 7.36579 12.3831 7.76116 12.3831 8.24887V11.1952L14.9516 11.1918Z",
    fill: "#2D6CE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.81d82d65c4fed1a55946d6126eda47cb.svg";
export { ForwardRef as ReactComponent };